var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFairoLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.992739C0 0.444465 0.461014 0 1.0297 0H10.234C11.7616 0 13 1.19391 13 2.66667C13 4.13943 11.7616 5.33333 10.234 5.33333H1.0297C0.461013 5.33333 0 4.88887 0 4.34059V0.992739ZM0.755846 16C0.338404 16 0 15.6737 0 15.2713V9.46667C0 7.99391 1.23836 6.8 2.76596 6.8C4.29355 6.8 5.53191 7.99391 5.53191 9.46667V15.2713C5.53191 15.6737 5.19351 16 4.77607 16H0.755846ZM7.05843 8.81225C6.84238 8.90774 6.84508 9.2046 7.06282 9.29643L10.0707 10.5649C11.224 11.0513 12.516 10.2367 12.516 9.02302C12.516 7.79664 11.1991 6.98205 10.0428 7.49314L7.05843 8.81225Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFairoLogoWhite);
export default __webpack_public_path__ + "static/media/fairo-logo-white.9f36f2bec71372850048ca3f33e2553a.svg";
export { ForwardRef as ReactComponent };